import { useCreateSmsSnippetMutation } from "../../../../../../api/smsSnippets/useCreateSmsSnippetMutation";
import { useUpdateSmsSnippetMutation } from "../../../../../../api/smsSnippets/useUpdateSmsSnippetMutation";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../services/UINotificationService";
import { extractApiError } from "../../../../../../utilities/api";
import { getPathParams } from "../utilities";

export const useSubmit = () => {
  const { id } = getPathParams();

  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "smsSnippets",
  });

  const createOne = useCreateSmsSnippetMutation({
    onError: (res) => {
      const message = extractApiError(res);
      uiNotification.error(t([`error.${message}`, "error.createOne"]));
    },
    onSuccess: () => {
      uiNotification.success(t("success.createOne"));
    },
  });

  const updateOne = useUpdateSmsSnippetMutation({
    onError: (res) => {
      const message = extractApiError(res);
      uiNotification.error(t([`error.${message}`, "error.updateOne"]));
    },
    onSuccess: () => {
      uiNotification.success(t("success.updateOne"));
    },
  });

  return {
    isLoading: createOne.isLoading || updateOne.isLoading,
    initiate: (values) => {
      if (id) {
        return updateOne.mutateAsync({
          id,
          ...values,
        });
      } else {
        return createOne.mutateAsync(values);
      }
    },
  };
};
